import React from "react";

import { Layout, Button, Typography, Flex } from "antd";
import { Outlet, Link, useLocation } from "react-router-dom";
import SettingsSidebarMenu from "./SettingsSidebarMenu";
import CustomIcon from "../components/layouts/CustomIcon";
import AuthProvider from "../components/user/AuthProvider";
import DesktopProvider from "../components/DesktopProvider";
import GlobalAppShell from "../components/layouts/GlobalAppShell";

const { Sider, Content, Header } = Layout;

export default function SettingsLayout() {
  const { state } = useLocation();

  return (
    <AuthProvider fetchReqDetails fetchBalances>
      <DesktopProvider>
        <GlobalAppShell>
          <Layout className='h-100'>
            <Header className='h-52px lh-1 p-8-24px'>
              <Flex gap={16} align='center'>
                <Link to={state?.from || "/"}>
                  <Button type='text' icon={<CustomIcon name='arrow_left' />} />
                </Link>
                <Typography.Title level={5} className='m-0 font-size-16px fw-600'>
                  Settings
                </Typography.Title>
              </Flex>
            </Header>
            <Content style={{ paddingLeft: 24, paddingRight: 40, height: "calc(100vh - 52px)" }}>
              <Layout hasSider className='h-100 gap-22px'>
                <Sider width={280} theme='light'>
                  <SettingsSidebarMenu />
                </Sider>
                <Content className='h-100 overflow-hidden px-40px' style={{ width: "min(100%, 980px)" }}>
                  <Outlet />
                </Content>
              </Layout>
            </Content>
          </Layout>
        </GlobalAppShell>
      </DesktopProvider>
    </AuthProvider>
  );
}
